<template>
  <div
    v-if="configInfo"
    class="container"
    :style="
      `padding:0 ${space}px;` +
      (configInfo.backgroundImageUrl
        ? `background-image:url(${
            configInfo.bgImageKey === 'custom'
              ? configInfo.backgroundImageUrl
              : require('../../assets/images/priceSign/vertical-bg-' +
                  configInfo.bgImageKey +
                  '.jpg')
          })`
        : `background-color:white`)
    "
  >
    <div
      class="top"
      :style="`height:${configInfo.topBarProportion * 100}%;width:100%`"
    >
      <div
        v-if="configInfo.hotelNameShowType === 0"
        class="hotel-name"
        :style="`padding:${configInfo.hotelNameSize / 4}px ${
          configInfo.hotelNameSize
        }px;background-color:${configInfo.hotelNameBackgroundColorRgba};`"
      >
        <div
          v-if="configInfo.hotelIconSvg"
          v-html="configInfo.hotelIconSvg"
          :style="{
            width: configInfo.hoteIconSize + 'px',
            height: configInfo.hoteIconSize + 'px',
            display: 'inline-block'
          }"
        />
        <span
          class="text"
          :style="`font-size:${configInfo.hotelNameSize}px;color:${
            configInfo.hotelNameColor
          };line-height${configInfo.hotelNameSize * 1.4}px;margin-left:${
            configInfo.hotelNameSize / 4
          }px`"
          >{{ configInfo.hotelName }}
        </span>
      </div>
      <img
        v-else
        class="hotel-logo"
        :style="`border-radius:${configInfo.hotelLogoRadius}px`"
        :src="configInfo.hotelLogoUrl"
        alt=""
      />
      <!-- 时间字体大小为酒店名字体的一半 -->
      <div
        class="time"
        :style="`color:${configInfo.hotelNameColor};font-size:${configInfo.timeSize}px;`"
      >
        {{ timeInfo.day }}<br />{{ timeInfo.dayOfWeek + ' ' + timeInfo.time }}
      </div>
    </div>
    <div
      class="center"
      :style="`height:calc(100% - ${
        (configInfo.topBarProportion + configInfo.bottomBarProportion) * 100
      }%`"
    >
      <div
        ref="pricesRef"
        class="room-types-prices"
        :style="
          configInfo.advertisingType === 3 ||
          configInfo.advertisingProportion == 0
            ? 'height:100%'
            : `height:calc(100% - ${space}px - (100% - ${space}px) * ${configInfo.advertisingProportion})`
        "
      >
        <template v-if="configInfo.roomTypeShowType == 0">
          <div
            class="item"
            :style="`height:${100 / (configInfo.displayRows + 1)}%;font-size:${
              configInfo.titleSize
            }px;color:${configInfo.titleColor};background-color:${
              configInfo.roomTypeTitleBackgroundColorRgba
            };border-radius: ${configInfo.roomTypeRadius}px ${
              configInfo.roomTypeRadius
            }px 0 0`"
          >
            <div
              class="room-type"
              :style="`width:${configInfo.roomTypeNameWidthProportion * 100}%;`"
            >
              房型
            </div>
            <div
              v-for="(priceTypeName, priceTypeNameIndex) in priceTypeNames"
              :key="priceTypeNameIndex"
              class="price"
              :style="`width:${
                (100 - configInfo.roomTypeNameWidthProportion * 100) /
                priceTypeNames.length
              }%;`"
            >
              {{ priceTypeName }}
            </div>
          </div>
          <div
            :style="`width:100%;height:${
              100 - 100 / (configInfo.displayRows + 1)
            }%;background-color:${
              configInfo.roomTypeContentBackgroundColorRgba
            };border-radius:0 0 ${configInfo.roomTypeRadius}px ${
              configInfo.roomTypeRadius
            }px;`"
          >
            <div
              v-for="(item, index) in roomTypePages[roomTypePageIndex]"
              :key="index"
              class="item"
              :style="`height:${100 / configInfo.displayRows}%;`"
            >
              <div
                class="room-type"
                :style="`width:${
                  configInfo.roomTypeNameWidthProportion * 100
                }%;font-size:${configInfo.roomTypeSize}px;color:${
                  configInfo.roomTypeColor
                };`"
              >
                <template v-if="item.full">
                  <span
                    class="name"
                    :style="`max-width: calc(100% - ${
                      configInfo.fullSize * 2 * 1.2
                    }px);padding-right:${configInfo.roomTypeSize / 3}px`"
                  >
                    {{ item.roomTypeName }}</span
                  >
                  <!-- 设置满房标记圆角和昌都 -->
                  <span
                    class="full"
                    :style="`font-size:${configInfo.fullSize}px;border-radius:${
                      configInfo.fullSize / 3
                    }px;width:${configInfo.fullSize * 2 * 1.2}px`"
                    >满房</span
                  >
                </template>
                <span v-else class="name" style="max-width: 100%">
                  {{ item.roomTypeName }}</span
                >
              </div>
              <div
                v-for="(price, priceIndex) in item.prices"
                :key="priceIndex"
                :style="`width:${
                  (100 - configInfo.roomTypeNameWidthProportion * 100) /
                  priceTypeNames.length
                }%;font-size:${configInfo.roomPriceSize}px;color:${
                  configInfo.roomPriceColor
                };`"
                class="price"
              >
                {{ price }}
              </div>

              <!-- <div
                  v-for="(price, priceIndex) in item.prices"
                  :key="priceIndex"
                  class="price"
                  :style="`font-size:${configInfo.roomPriceSize}px;color:${configInfo.roomPriceColor};`"
                >
                  {{ price }}
                </div> -->
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="item"
            :style="`height:${100 / (configInfo.displayRows + 1)}%;font-size:${
              configInfo.titleSize
            }px;color:${configInfo.titleColor};background-color:${
              configInfo.zebraStripingColorRgba
            };border-radius: ${configInfo.zebraStripingRadius}px;`"
          >
            <div
              class="room-type"
              :style="`width:${configInfo.roomTypeNameWidthProportion * 100}%;`"
            >
              房型
            </div>
            <div
              v-for="(priceTypeName, priceTypeNameIndex) in priceTypeNames"
              :key="priceTypeNameIndex"
              class="price"
              :style="`width:${
                (100 - configInfo.roomTypeNameWidthProportion * 100) /
                priceTypeNames.length
              }%;`"
            >
              {{ priceTypeName }}
            </div>
          </div>
          <div
            v-for="(item, index) in roomTypePages[roomTypePageIndex]"
            :key="index"
            class="item"
            :style="
              `height:${100 / (configInfo.displayRows + 1)}%;` +
              (index % 2 == 1
                ? `background-color:${configInfo.zebraStripingColorRgba};border-radius: ${configInfo.zebraStripingRadius}px;`
                : '')
            "
          >
            <div
              class="room-type"
              :style="`width:${
                configInfo.roomTypeNameWidthProportion * 100
              }%;font-size:${configInfo.roomTypeSize}px;color:${
                configInfo.roomTypeColor
              };`"
            >
              <template v-if="item.full">
                <span
                  class="name"
                  :style="`max-width: calc(100% - ${
                    configInfo.fullSize * 2 * 1.2
                  }px);padding-right:${configInfo.roomTypeSize / 3}px`"
                >
                  {{ item.roomTypeName }}</span
                >
                <!-- 设置满房标记圆角和昌都 -->
                <span
                  class="full"
                  :style="`font-size:${configInfo.fullSize}px;border-radius:${
                    configInfo.fullSize / 3
                  }px;width:${configInfo.fullSize * 2 * 1.2}px`"
                  >满房</span
                >
              </template>
              <span v-else class="name" style="max-width: 100%">
                {{ item.roomTypeName }}</span
              >
            </div>
            <div
              v-for="(price, priceIndex) in item.prices"
              :key="priceIndex"
              :style="`width:${
                (100 - configInfo.roomTypeNameWidthProportion * 100) /
                priceTypeNames.length
              }%;font-size:${configInfo.roomPriceSize}px;color:${
                configInfo.roomPriceColor
              };`"
              class="price"
            >
              {{ price }}
            </div>

            <!-- <div
                  v-for="(price, priceIndex) in item.prices"
                  :key="priceIndex"
                  class="price"
                  :style="`font-size:${configInfo.roomPriceSize}px;color:${configInfo.roomPriceColor};`"
                >
                  {{ price }}
                </div> -->
          </div>
        </template>
      </div>
      <div
        v-if="
          configInfo.advertisingType !== 3 &&
          configInfo.advertisingProportion !== 0
        "
        ref="advertisingRef"
        class="carousel column"
        :style="`margin-top:${space}px;height:${
          configInfo.advertisingProportion * 100
        }%;`"
      >
        <!-- 显示自定义图片 -->
        <img
          v-if="configInfo.advertisingType === 1"
          class="carousel-content"
          :style="`border-radius: ${configInfo.advertisingRadius}px;`"
          :src="configInfo.selfImageUrl"
          alt=""
        />
        <!-- 显示自定义视频 -->
        <video
          v-else-if="configInfo.advertisingType === 2"
          class="carousel-content"
          :src="configInfo.selfVideoUrl"
          autoplay
          playsinline
          loop
        ></video>
        <!-- 其余都显示房型图片 -->
        <template v-else>
          <a-carousel
            ref="advertisingCarouselRef"
            class="carousel-content"
            :dots="false"
            :autoplay="false"
          >
            <div
              class="carousel-content-item"
              v-for="item in roomTypes"
              :key="item.id"
            >
              <img
                :src="item.cover"
                alt=""
                :style="`border-radius: ${configInfo.advertisingRadius}px;`"
              />
              <div
                v-if="advertisingRoomTypeFontSize"
                class="room-type-name"
                :style="`height:${
                  advertisingRoomTypeNameContainerRatio * 100
                }%;font-size:${advertisingRoomTypeFontSize}px;border-radius:0 0 ${
                  configInfo.advertisingRadius
                }px ${configInfo.advertisingRadius}px;`"
              >
                <span class="text">{{ item.roomTypeName }}</span>
              </div>
            </div>
          </a-carousel>
        </template>
      </div>
    </div>
    <div
      v-if="configInfo.notice"
      ref="noticeContainerRef"
      class="bottom"
      :style="`height:${configInfo.bottomBarProportion * 100}%;`"
    >
      <div
        class="notice"
        :style="`font-size:${configInfo.noticeSize}px;color:${configInfo.noticeColor};`"
      >
        <div v-if="!noticeWidthInfo" class="count-notice-width-content">
          <span ref="countNoticeWidthRef">{{ configInfo.notice }}</span>
        </div>
        <template v-else>
          <div
            v-if="
              noticeWidthInfo.noticeWidth <=
              noticeWidthInfo.noticeContainerWidth
            "
            class="notice-text-not-scroll"
          >
            {{ configInfo.notice }}
          </div>
          <div
            v-else
            class="notice-text-scroll"
            :style="`animation-duration:${
              noticeWidthInfo.animationDuration
            }s;padding-left:${
              noticeWidthInfo.noticeWidth > noticeWidthInfo.noticeContainerWidth
                ? noticeWidthInfo.noticeContainerWidth
                : noticeWidthInfo.noticeWidth
            }px`"
          >
            <span>{{ configInfo.notice }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getBaseInfoNewApi, getConfigApi } from '@/api/priceSign'
// import priceSign2026TestData from '@/utils/priceSign2026TestData'
import priceSignPreviewUtil from '@/utils/priceSignUtilNew'
let audioContext = null
// 横版用 0
const SCREEN_TYPE_HORIZONTAL = 0
// 竖版用1
const SCREEN_TYPE_VERTICAL = 1

export default {
  name: 'VerticalPriceSign',
  data() {
    return {
      hotelId: null,
      // 酒店信息 会员等级信息 房型信息
      hotelInfo: null,
      // 标准高度
      standardHeight: 1920,
      // 标准宽度
      standardWidth: 1080,
      // 标准间距
      standardSpace: 50,

      // 酒店信息 会员等级信息 房型信息
      baseInfo: null,
      // 左右间距和上下间距
      space: 0,
      roomTypes: [],
      configInfo: null,
      timeInfo: null,
      // 价格类型
      priceTypeNames: null,
      // 房型价格
      roomTypePages: null,
      // 当前第几页
      roomTypePageIndex: 0,
      // 价格滚动前后固定显示时间
      priceShowTime: 2500,
      // 房型滚动完成监听
      scrollPriceEventListener: null,
      // noticeNeedScroll: false,
      noticeWidthInfo: null,
      // 时间刷新
      timeRefreshInterval: null,
      // 定时刷新房型显示
      showRoomTypeInterval: null,
      // 定时检查更新
      checkUpdateInterval: null,
      // 上一次请求的配置的json，用来和定时更新的信息进行比较看是否更新
      lastHotelRoomTypesDiscountJson: null,
      lastConfigInfoJson: null,
      lastRoomTypesJson: null,

      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,

      // 广告房型字体容器比例比例
      advertisingRoomTypeNameContainerRatio: 0.2,
      // 广告房型字体大小
      advertisingRoomTypeFontSize: 0,
      // 广告轮播定时器
      advertisingInterval: null
    }
  },
  computed: {
    roomTypePrice() {
      if (!this.roomTypePages || this.roomTypePages.length === 0) {
        return null
      }
      return this.roomTypePages[this.roomTypePageIndex]
    }
  },
  mounted() {
    const hotelId = this.$route.query.hotelId || this.$route.query.hid
    if (hotelId) {
      this.hotelId = hotelId
      this.init()
      return
    }
    // eslint-disable-next-line dot-notation
    window['initData'] = (hotelId) => {
      this.hotelId = hotelId
      this.init()
    }
  },
  beforeDestroy() {
    // 清理定时器
    if (this.timeRefreshInterval) {
      clearInterval(this.timeRefreshInterval)
    }
    if (this.checkUpdateInterval) {
      clearInterval(this.checkUpdateInterval)
    }
    if (this.showRoomTypeInterval) {
      clearInterval(this.showRoomTypeInterval)
    }
    // 停止广告轮播
    this.stopAdvertisingCarousel()
    // 停止播放音乐
    if (audioContext && audioContext.state === 'running') {
      audioContext.suspend()
    }
    // 移除事件监听
    if (this.scrollPriceEventListener && this.$refs.pricesRef) {
      this.$refs.pricesRef.removeEventListener(
        this.scrollPriceEventListener.event,
        this.scrollPriceEventListener.handler
      )
    }
  },
  methods: {
    async init() {
      this.showTime()
      this.initAndShowData()
      this.startCheckUpdate()
    },

    /**
     * 初始化并且显示数据
     */
    async initAndShowData() {
      const pageData = await this.getData()
      if (!pageData) {
        return
      }
      const configInfoValue = pageData.configInfoValue
      // 显示类型，如果是竖版跳转到竖版
      if (configInfoValue.screenType === 0) {
        this.$router.push({
          path: '/priceSignHorizontalNew',
          query: { hotelId: this.hotelId }
        })
        return
      }
      const baseInfoValue = pageData.baseInfoValue
      const roomTypesValue = pageData.roomTypesValue

      const hotelRoomTypesDiscountJson = JSON.stringify(
        baseInfoValue.hotelRoomTypesDiscount
      )
      const roomTypesJson = JSON.stringify(roomTypesValue)
      const configInfoJson = JSON.stringify(configInfoValue)

      // 是否更新了
      const isNeedUpdate =
        hotelRoomTypesDiscountJson !== this.lastHotelRoomTypesDiscountJson ||
        configInfoJson !== this.lastConfigInfoJson ||
        roomTypesJson !== this.lastRoomTypesJson
      if (!isNeedUpdate) {
        return
      }
      this.lastHotelRoomTypesDiscountJson = hotelRoomTypesDiscountJson
      this.lastConfigInfoJson = configInfoJson
      this.lastRoomTypesJson = roomTypesJson
      this.space = this.getSpace()
      const showInfo = await priceSignPreviewUtil.getShowInfo(
        configInfoValue,
        roomTypesValue,
        baseInfoValue.hotelRoomTypesDiscount,
        baseInfoValue.userLevelConf,
        this.standardHeight
      )
      this.baseInfo = baseInfoValue
      this.roomTypes = roomTypesValue

      this.priceTypeNames = showInfo.priceTypeNames
      this.roomTypePages = showInfo.roomTypePages
      this.configInfo = showInfo.configInfo
      this.showConfig()
    },

    /**
     * 获取数据
     */
    async getData() {
      // 电子房价牌原始配置
      const configInfoValue = await this.getConfigInfo()
      if (configInfoValue == null) {
        return null
      }
      // 显示类型，如果是横版跳转到横版
      if (configInfoValue.screenType === SCREEN_TYPE_HORIZONTAL) {
        return {
          configInfoValue
        }
      }
      const baseInfoValue = await this.getBaseInfo()
      if (!baseInfoValue) {
        return null
      }
      // 房型信息
      const roomTypesValue = await priceSignPreviewUtil.getRoomTypes(
        baseInfoValue.hotelInfo.id,
        configInfoValue.roomTypeConfList,
        SCREEN_TYPE_VERTICAL
      )
      return {
        configInfoValue,
        baseInfoValue,
        roomTypesValue
      }
    },

    /**
     * 获取酒店和会员级别信息
     */
    async getBaseInfo() {
      const data = await getBaseInfoNewApi(this.hotelId, SCREEN_TYPE_VERTICAL)
      // const data = priceSign2026TestData.getBaseInfoNewApiTest(this.hotelId)
      if (data.code !== 0) {
        return null
      }
      return data.data
    },

    // 获取间距
    getSpace() {
      const width =
        (window.innerHeight * this.standardWidth) / this.standardHeight
      return (this.standardSpace / this.standardWidth) * width
    },

    /**
     * 显示时间
     */
    showTime() {
      this.timeInfo = priceSignPreviewUtil.getCurrentTime()
      this.timeRefreshInterval = setInterval(() => {
        this.timeInfo = priceSignPreviewUtil.getCurrentTime()
      }, 5 * 1000)
    },

    /**
     * 获取配置信息
     */
    async getConfigInfo() {
      // 先取横版
      let configInfoValue = await this.getConfigInfoWithScreenType(
        SCREEN_TYPE_VERTICAL
      )
      if (configInfoValue) {
        configInfoValue.screenType = SCREEN_TYPE_VERTICAL
        return configInfoValue
      }
      // 没有横版取竖版
      configInfoValue = await this.getConfigInfoWithScreenType(
        SCREEN_TYPE_HORIZONTAL
      )
      if (configInfoValue) {
        configInfoValue.screenType = SCREEN_TYPE_HORIZONTAL
        return configInfoValue
      }
      return null
    },

    /**
     * 根据方向获取配置信息
     * @param {number} screenType - 屏幕类型，0-横版,1-竖版
     */
    async getConfigInfoWithScreenType(screenType) {
      const data = await getConfigApi(this.hotelId, screenType)
      if (data.code !== 0) {
        return null
      }
      return data.data
    },

    /**
     * 显示配置
     */
    showConfig() {
      this.$nextTick(() => {
        this.showPagesNotScrollPriceInfo()
        this.getNoticeWidth()
        this.startAdvertisingCarousel()
        this.calculateAdvertisingRoomTypeFontSize()
      })
      if (this.configInfo.backgroundMusicType === 1) {
        this.playBackgroundMusic()
      }
    },

    startShowPriceInfo() {
      if (this.showRoomTypeInterval) {
        clearInterval(this.showRoomTypeInterval)
      }
      const pricesView = this.$refs.pricesRef
      pricesView.style.transition = ''
      pricesView.style.transform = 'none'

      // 有多少个价格类型
      const priceTypeInfoList = this.roomTypePrice.priceTypeInfoList
      // 一页显示多少个价格类型
      const pageShowPriceTypeCount = this.configInfo.pageShowPriceTypeCount
      // 如果一页能显示完，那么不滚动
      if (pageShowPriceTypeCount >= priceTypeInfoList.length) {
        this.showPagesNotScrollPriceInfo()
        return
      }
      this.showPagesScrollPriceInfo()
    },

    /**
     * 开始定时检查更新
     */
    startCheckUpdate() {
      if (this.checkUpdateInterval) {
        clearInterval(this.checkUpdateInterval)
      }
      this.checkUpdateInterval = setInterval(() => {
        this.initAndShowData()
      }, 60 * 1000)
    },

    /**
     * 获取下一页
     */
    getNextRoomTypePageIndex() {
      // 动画结束时的操作
      let newRoomTypePageIndex = this.roomTypePageIndex + 1
      if (newRoomTypePageIndex >= this.roomTypePages.length) {
        newRoomTypePageIndex = 0
      }
      return newRoomTypePageIndex
    },

    /**
     * 不滚动房价
     */
    showPagesNotScrollPriceInfo() {
      if (this.showRoomTypeInterval) {
        clearInterval(this.showRoomTypeInterval)
      }
      if (this.roomTypePages.length > 1) {
        this.showRoomTypeInterval = setInterval(() => {
          // 需要显示的房型页
          const roomTypePageIndexValue = this.getNextRoomTypePageIndex()
          this.roomTypePageIndex = roomTypePageIndexValue
        }, this.configInfo.displayCycle * 1000)
      }
    },

    /**
     * 滚动房价
     */
    showPagesScrollPriceInfo() {
      this.addScrollPriceEventListener()
      this.doShowPagesScrollPriceInfo()
    },

    /**
     * 执行滚动
     */
    doShowPagesScrollPriceInfo() {
      setTimeout(() => {
        const configInfoValue = this.configInfo
        const priceTypeInfoList = this.roomTypePrice.priceTypeInfoList
        // 一页显示多少个价格类型
        const pageShowPriceTypeCount = configInfoValue.pageShowPriceTypeCount
        const translateX =
          (100 / pageShowPriceTypeCount) *
          (priceTypeInfoList.length - pageShowPriceTypeCount)

        const pricesView = this.$refs.pricesRef
        pricesView.style.transform = `translateX(-${translateX}%)`
        pricesView.style.transition = `transform ${configInfoValue.displayCycle}s linear`
      }, this.priceShowTime)
    },

    /**
     * 添加滚动完监听
     */
    addScrollPriceEventListener() {
      const pricesView = this.$refs.pricesRef
      const event = 'transitionend'
      if (this.scrollPriceEventListener) {
        pricesView.removeEventListener(
          this.scrollPriceEventListener.event,
          this.scrollPriceEventListener.handler
        )
      }
      const handler = (event) => {
        if (event.propertyName.includes('transform')) {
          //  动画结束显示一定时间后显示下一页
          setTimeout(() => {
            // 需要显示的房型页
            const roomTypePageIndexValue = this.getNextRoomTypePageIndex()
            if (this.roomTypePageIndex !== roomTypePageIndexValue) {
              this.roomTypePageIndex = roomTypePageIndexValue
            }
            pricesView.style.transition = ''
            pricesView.style.transform = 'none'
            this.doShowPagesScrollPriceInfo()
          }, this.priceShowTime)
        }
      }
      this.scrollPriceEventListener = {
        event,
        handler
      }
      pricesView.addEventListener(event, handler, false)
    },

    /**
     * 公告宽度信息
     */
    getNoticeWidth() {
      if (!this.$refs.countNoticeWidthRef) {
        return
      }
      const noticeWidth = this.$refs.countNoticeWidthRef.offsetWidth
      const noticeContainerWidth = this.$refs.noticeContainerRef.offsetWidth
      if (noticeWidth > noticeContainerWidth) {
        // 满一页动画时间
        const pageTime = 20
        const animationDuration =
          (noticeWidth / noticeContainerWidth) * pageTime
        this.noticeWidthInfo = {
          noticeWidth,
          noticeContainerWidth,
          animationDuration
        }
        return
      }
      this.noticeWidthInfo = {
        noticeWidth,
        noticeContainerWidth
      }
    },

    playBackgroundMusic() {
      if (!audioContext) {
        audioContext = new window.AudioContext()
      }
      if (audioContext.state === 'running') {
        audioContext.suspend()
      }
      const request = new XMLHttpRequest()
      request.open('GET', this.configInfo.backgroundMusicUrl, true)
      request.responseType = 'arraybuffer'
      request.onload = () => {
        audioContext.decodeAudioData(request.response, (buffer) => {
          const source = audioContext.createBufferSource()
          source.buffer = buffer
          source.loop = true
          source.connect(audioContext.destination)
          source.start()
        })
      }
      request.send()
    },

    // 广告房型字体大小
    calculateAdvertisingRoomTypeFontSize() {
      if (this.$refs.advertisingRef) {
        // 获取div的实际高度（包括padding，不含border：clientHeight；含border用offsetHeight）
        const divHeight = this.$refs.advertisingRef.clientHeight
        // 计算字体大小为高度的一半
        this.advertisingRoomTypeFontSize =
          divHeight * this.advertisingRoomTypeNameContainerRatio * 0.4
      }
    },

    // 启动广告轮播
    startAdvertisingCarousel() {
      // 清除之前的定时器
      if (this.advertisingInterval) {
        clearInterval(this.advertisingInterval)
      }
      // 只有当有显示房型并且有多个房型且才启动
      if (
        this.$refs.advertisingCarouselRef &&
        this.roomTypes &&
        this.roomTypes.length > 1
      ) {
        this.advertisingInterval = setInterval(() => {
          // 切换到下一张广告
          if (this.$refs.advertisingCarouselRef) {
            this.$refs.advertisingCarouselRef.next()
          }
        }, this.configInfo.advertisingCycle * 1000)
      }
    },

    // 停止广告轮播
    stopAdvertisingCarousel() {
      if (this.advertisingInterval) {
        clearInterval(this.advertisingInterval)
        this.advertisingInterval = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.container {
  width: 100vw;
  height: 100vh;
  text-align: left;
  color: white;
  display: flex;
  flex-direction: column;
  background-size: cover;
  background-position: center; /* 确保图像居中 */
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .hotel-name {
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 60px 60px 60px 60px;
    max-width: 60%;
    .text {
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .hotel-logo {
    height: 80%;
    object-fit: cover;
    max-width: 70%;
  }

  .time {
    text-align: right;
    width: 35%;
    margin-left: 5%;
    overflow-y: hidden;
  }
}

.center {
  display: flex;
  flex-direction: column;
  .room-types-prices {
    display: flex;
    flex-direction: column;
    width: 100%;
    .item {
      width: 100%;
      display: flex;
      flex-direction: row;
      .room-type {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 3%;
        .name {
          white-space: nowrap; /* 防止文本换行 */
          overflow: hidden; /* 隐藏溢出的内容 */
          text-overflow: ellipsis; /* 显示省略号 */
        }

        .full {
          text-align: center;
          background-color: #ff0000;
          color: white;
        }
      }
      .price {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
    }
  }
}

// .center_no-bottom {
//   height: calc(100vh - 80px);
// }

// .room-types-prices {
//   padding-bottom: 20px;
//   position: relative;

//   .room-types-prices-bg {
//     width: 100%;
//     height: calc(100% - 20px);
//     position: absolute;
//     left: 0;
//     top: 0;
//     div {
//       width: 100%;
//     }
//   }
//   .room-types-prices-container {
//     font-size: 19px;
//     width: 100%;
//     height: calc(100% - 20px);
//     position: absolute;
//     left: 0;
//     top: 0;

//     div,
//     span {
//       flex-shrink: 0;
//     }

//     .room-type-item {
//       padding-left: 20px;
//       display: flex;
//       align-items: center;
//       box-sizing: border-box;

//       .name {
//         white-space: nowrap; /* 防止文本换行 */
//         overflow: hidden; /* 隐藏溢出的内容 */
//         text-overflow: ellipsis; /* 显示省略号 */
//       }

//       .full {
//         width: 35px;
//         font-size: 13px;
//         text-align: center;
//         background-color: #ff0000;
//         border-radius: 5px;
//         margin-left: 5px;
//         color: white;
//       }
//     }

//     .room-price-item {
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }

//     .room-types-header {
//       width: 100%;
//       display: flex;
//       align-items: center;
//     }

//     .price-sign-content {
//       width: 100%;
//       height: 100%;
//       display: flex;
//       align-items: center;
//       justify-content: center;

//       .room-types {
//         height: 100%;

//         .room-types-header {
//           padding-left: 20px;
//         }

//         .room-types-item {
//           padding-left: 20px;
//           width: 100%;
//           display: flex;
//           align-items: center;

//           .name {
//             white-space: nowrap; /* 防止文本换行 */
//             overflow: hidden; /* 隐藏溢出的内容 */
//             text-overflow: ellipsis; /* 显示省略号 */
//           }

//           .full {
//             width: 40px;
//             text-align: center;
//             background-color: #ff0000;
//             font-size: 15px;
//             border-radius: 5px;
//             margin-left: 5px;
//             color: white;
//           }
//         }

//         @keyframes priceScroll {
//           0% {
//             -webkit-transform: translateX(0);
//             transform: translateX(0);
//           }
//           100% {
//             -webkit-transform: translateX(-100%);
//             transform: translateX(-100%);
//           }
//         }
//       }
//       .prices-container {
//         overflow-x: hidden;
//         width: 100%;
//         height: 100%;

//         .prices {
//           width: 100%;
//           height: 100%;
//           text-align: center;

//           .room-types-header {
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }

//           .room-types-item {
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             font-size: 19px;
//           }
//         }
//       }
//     }
//   }
// }

.carousel {
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
  }

  .carousel-content {
    width: 100%;
    height: 100%;

    .carousel-content-item {
      width: 100%;
      height: 100%;
      position: relative;

      .room-type-name {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white !important;
        .text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 20px;
          box-sizing: border-box;
        }
      }
    }
  }
}

::v-deep .ant-carousel div {
  height: 100%;
}

.bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;

  .notice {
    font-weight: 700;
    display: flex;
    width: 100%;
    align-items: center;
    text-align: center;
    position: relative;

    .count-notice-width-content {
      position: absolute;
      left: 100%;
      white-space: nowrap;
      display: inline-block;
    }

    .notice-text-not-scroll {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
    }

    @keyframes noticeScroll {
      0% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
      100% {
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
      }
    }

    .notice-text-scroll {
      white-space: nowrap;
      display: inline-block;
      overflow: hidden;
      -webkit-animation: 5s noticeScroll linear infinite;
      animation: 5s noticeScroll linear infinite;
      position: absolute;
      left: 0;
    }
  }
}
</style>
